module.exports = __webpack_public_path__ + "img/bracket-10.04df520b.svg";